<div class="dropdown">
  <a  class="nav-link dropdown-toggle"  href="#" role="button"  data-bs-toggle="dropdown" aria-expanded="false" id="dropdownMenuReport">

    <div class="d-none d-md-block"> <i class='fa fa-line-chart'></i></div>
    <i class='fa fa-line-chart d-md-none'></i>

    Reports
    <span class="caret"></span></a>

<div class="dropdown-menu" role="menu" *ngIf="gatePass.is_role_guardian" aria-labelledby="dropdownMenuReport">
<a [routerLink]="['/award/guardian',gatePass.user_id]" class="nav-link nav-main-white dropdown-item"> Awards </a>
<a [routerLink]="['/report/guardian',gatePass.user_id]" class="nav-link nav-main-white dropdown-item"> Progress </a>
</div>

<div class="dropdown-menu" role="menu" *ngIf="gatePass.is_role_student">
    <a [routerLink]="['/award/student',gatePass.user_id]" class="nav-link nav-main-white dropdown-item"> Awards </a>
    <a [routerLink]="['/report/student',gatePass.user_id]" class="nav-link nav-main-white dropdown-item"> Progress </a>
</div>
</div>
